import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import { ContractTabTemplates } from "@/business/contract/ContractTabTemplates";
import { ContractPinGate } from "@/business/contract/ContractPinGate";

/** 계약서 양식 (템플릿) — CRUD + 임포트 */
export const Route = createFileRoute("/business/layout/contract-templates")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <LayoutHeader title="계약서 양식" hasBackBtn hasFootPrint={false} />
      <ContractPinGate ownerOnly>
        <div className="flex-1 min-h-0 flex flex-col bg-[#F5F5F5]">
          <div className="flex-1 min-h-0 overflow-y-auto pt-2">
            <ContractTabTemplates />
          </div>
        </div>
      </ContractPinGate>
    </>
  );
}
